.poster {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 1s ease;
}

.hidden {
  opacity: 0;
  pointer-events: none;
}

.preload {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.fallback {
  position: absolute;
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-p, 16px);
  font-weight: 400;
  line-height: 1.7;
  color: var(--color\/text\/text-secondary, #bababa);
  margin: 0;
}
